import React from "react";

export default function Left() {
  return (
    <svg width="18" height="32" viewBox="0 0 18 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2811 31.2601C18.2396 30.2735 18.2396 28.6739 17.2811 27.6873L5.9258 16L17.2811 4.31269C18.2396 3.32611 18.2396 1.72653 17.2811 0.739943C16.3225 -0.246647 14.7684 -0.246647 13.8098 0.739943L0.71892 14.2136C-0.23964 15.2002 -0.23964 16.7998 0.71892 17.7864L13.8098 31.2601C14.7684 32.2466 16.3225 32.2466 17.2811 31.2601Z"
        fill="#000"
      />
    </svg>
  );
}
